/* unplugin-vue-components disabled */import script from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=e14b5baa&lang=scss&scoped=true"

import exportComponent from "/Users/zouchanghua/Documents/project/xrverse/xrweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e14b5baa"]])

export default __exports__